<template>
  <div class="container">
    <w-navbar
      v-show="iosOrAndroidShow"
      :icon="'iconchevron-left'"
      :cvShow="true"
      @mobileLeftBtn="leftBtnClick"
    />
    <div class="title">发送简历至邮箱</div>
    <div class="desc">输入您的邮箱地址，简历将以PDF格式发送至您的邮箱</div>
    <div class="email-title">邮箱账号</div>
    <input
      class="email-input"
      :class="tips?'active':''"
      placeholder="请输入您的邮箱账户"
      type="email"
      v-model="email"
      maxlength="64"
      @input="handleChangeEmail"
    />
    <div class="tips-box">
      <div class="tips" v-if="tips">
        <img class="tips-img" src="https://files.wondercv.com/tips.png" />
        <div class="tips-text">请输入正确的邮箱地址</div>
      </div>
    </div>
    <div class="send-btn" :class="email.length?'active':''" @click="handleClickSend">发送到邮箱</div>
    <div class="cv-detail">
      <img src="https://files.wondercv.com/pdf%402x.png" alt class="cv-detail-img" />
      <div class="cv-name">{{cv_name}}</div>
    </div>
  </div>
</template>
<script>
import WNavbar from "@/components/global/w-navbar";
import { componentsMixin } from "@/assets/js/mixin/components";
export default {
  data() {
    return {
      iosOrAndroidShow: true,
      email: "",
      tips: false,
      emailUrl: "",
      cv_name: "",
      hideProfile: false
    };
  },
  mixins: [componentsMixin],
  components: {
    WNavbar
  },
  created() {
    console.log(typeof this.$route.query.hideProfile)
    this.cv_name = this.$route.query.cv_name ? this.$route.query.cv_name : "";
    this.hideProfile = this.$route.query.hideProfile === 'false' ? false : true;
    this.getDetail();
  },
  methods: {
    leftBtnClick() {
      this.$router.back();
    },
    handleChangeEmail() {
      this.tips = false;
    },
    handleClickSend() {
      if (!this.email.length) {
        this.showToast("请输入邮箱");
        return;
      }
      let reg = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
      if (reg.test(this.email)) {   
        this.$api.nps
          .sendEmail({
            token: this.$route.query.token,
            recipient_email: this.email,
            hideProfile: this.hideProfile,
            showProfile: !this.hideProfile
          })
          .then(res => {
            if (res.code === 1000) {
              this.showToast("发送成功", 1500);
              setTimeout(() => {
                this.$router.push(`/cvs/send-success?token=${this.$route.query.token}`)
              }, 1500)
            } else if(res.code == 80160) {
              this.$fn.jump(
                `/pages/member-buy/index`,
                () => {
                  this.$router.push(`/buy/member/order`)
                }
              )
            }
             else {
              this.showToast(res.message);
            }
          });
      } else {
        this.tips = true;
        return;
      }
    },
    //获取简历详情
    getDetail() {
    	this.$db.ls.remove('needToMail')
      let res = this.$api.cv.downloadCv(this.$route.query.token,{
        watermark: "no",
        hideProfile: this.hideProfile
      });
      res.then(res => {
        if (res.code == 1000) {
          this.emailUrl = res.data.url;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/global/variable";
@import "@/assets/scss/global/mixin";
.container {
  @include ipx-content-bottom(36px);
  margin: 0 24px;
  height: calc(100vh - 78px);
  position: relative;
  // padding-bottom: 56px;
  .title {
    margin-top: 78px;
    font-size: 18px;
    color: #404040;
    font-weight: 500;
  }
  .desc {
    font-size: 12px;
    color: #9c9c9c;
    margin-top: 12px;
  }
  .email-title {
    margin-top: 52px;
    font-size: 12px;
    color: #404040;
  }
  .email-input {
    display: block;
    border: none;
    border-bottom: 1px solid #eeeff0;
    height: 40px;
    padding: 0;
    font-size: 14px;
    width: 100%;
    border-radius: 0;
    color: #404040;
  }
  .email-input.active {
    border-bottom: 1px solid #ff4f4c;
  }
  .send-btn {
    position: absolute;
    bottom: 20px;
    left: 0;
    background: #cfcfcf;
    height: 46px;
    color: #fff;
    font-size: 16px;
    width: 100%;
    text-align: center;
    line-height: 46px;
    border-radius: 5px;
    font-weight: normal;
  }
  .send-btn.active {
    background: #ff4f4c;
  }
  .email-input::-webkit-input-placeholder {
    color: #bcbcbc;
  }
  .tips-box {
    height: 32px;
    overflow: hidden;
    .tips {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #ff4f4c;
      margin-top: 10px;
      margin-bottom: 10px;
      .tips-img {
        width: 12px;
        height: 12px;
        border: 1px solid #ff4f4c;
        color: #ff4f4c;
        text-align: center;
        line-height: 10px;
        font-size: 8px;
        border-radius: 50%;
        box-sizing: border-box;
        margin-right: 4px;
        border: none;
      }
      .tips-text {
        font-size: 12px;
        color: #ff4f4c;
      }
    }
  }
  .cv-detail {
    height: 51px;
    border: 1px solid #eeeff0;
    border-radius: 5px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    .cv-detail-img {
      width: 21px;
      height: 27px;
      margin-right: 8px;
    }
    .cv-name {
      width: 266px;
      color: #404040;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #bcbcbc;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #bcbcbc;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #bcbcbc;
  }
}
</style>
